/**
 * Nacon-owned — keep out of commercial theme JS (wiped on theme update).
 *
 * Dual Color × Platform cards: resolve the full variant after either radio
 * group changes, sync sold-out / incompatible UI, update media + links.
 * Incompatible pairs stay clickable and auto-switch the other axis.
 */
(function naconCardDualOptions() {
  var DUAL_SEL = '[data-nacon-card-dual]';
  var CARD_SEL = 'hdt-card-product';
  var SWATCH_GROUP = '.hdt-card-product__swatches';
  var PLATFORM_GROUP = '.hdt-card-product__platforms';
  var READY_ATTR = 'data-nacon-dual-ready';
  var cache = new WeakMap();
  var cssEscape =
    typeof CSS !== 'undefined' && typeof CSS.escape === 'function'
      ? CSS.escape.bind(CSS)
      : function (value) {
          return String(value).replace(/\\/g, '\\\\').replace(/"/g, '\\"');
        };

  function pushIndex(map, key, variant) {
    if (!key) return;
    (map[key] || (map[key] = [])).push(variant);
  }

  function parseDual(card) {
    var cached = cache.get(card);
    if (cached) return cached;

    var el = card.querySelector(DUAL_SEL);
    if (!el) return null;

    var raw;
    try {
      raw = JSON.parse(el.textContent);
    } catch (e) {
      return null;
    }
    if (!raw || !raw.variants || !raw.swatchKey || !raw.platformKey) return null;

    var byPair = Object.create(null);
    var bySwatch = Object.create(null);
    var byPlatform = Object.create(null);
    var i;
    var v;
    var s;
    var p;
    var key;

    for (i = 0; i < raw.variants.length; i++) {
      v = raw.variants[i];
      s = v[raw.swatchKey];
      p = v[raw.platformKey];
      if (!s || !p) continue;
      key = s + '\0' + p;
      if (!byPair[key] || (v.available && !byPair[key].available)) {
        byPair[key] = v;
      }
      pushIndex(bySwatch, s, v);
      pushIndex(byPlatform, p, v);
    }

    var data = {
      swatchKey: raw.swatchKey,
      platformKey: raw.platformKey,
      byPair: byPair,
      bySwatch: bySwatch,
      byPlatform: byPlatform,
    };
    cache.set(card, data);
    return data;
  }

  function findVariant(data, swatchVal, platformVal) {
    if (!data || !swatchVal || !platformVal) return null;
    return data.byPair[swatchVal + '\0' + platformVal] || null;
  }

  function axisList(data, key, value) {
    if (key === data.swatchKey) return data.bySwatch[value];
    if (key === data.platformKey) return data.byPlatform[value];
    return null;
  }

  function findCompatibleValue(data, fixedKey, fixedValue, otherKey) {
    var list = axisList(data, fixedKey, fixedValue);
    if (!list) return null;
    var fallback = null;
    var i;
    var v;
    var other;
    for (i = 0; i < list.length; i++) {
      v = list[i];
      other = v[otherKey];
      if (!other) continue;
      if (v.available) return other;
      if (!fallback) fallback = other;
    }
    return fallback;
  }

  function comboFlags(data, key, value, otherKey, otherValue) {
    var list = axisList(data, key, value);
    if (!list) {
      return { exists: false, available: false, availableAnywhere: false };
    }

    var availableAnywhere = false;
    var i;
    for (i = 0; i < list.length; i++) {
      if (list[i].available) {
        availableAnywhere = true;
        break;
      }
    }

    if (!otherValue) {
      return { exists: true, available: availableAnywhere, availableAnywhere: availableAnywhere };
    }

    var pair =
      key === data.swatchKey
        ? findVariant(data, value, otherValue)
        : findVariant(data, otherValue, value);

    return {
      exists: !!pair,
      available: !!(pair && pair.available),
      availableAnywhere: availableAnywhere,
    };
  }

  function setOptionState(item, label, hardSoldOut, incompatible) {
    if (!item || !label) return;
    var soft = !hardSoldOut && incompatible;
    item.classList.toggle('is-sold-out', hardSoldOut);
    item.classList.toggle('is-incompatible', soft);
    label.classList.toggle('is-disabled', hardSoldOut);
    label.classList.toggle('unavailable', hardSoldOut || soft);
    if (hardSoldOut) label.setAttribute('is-disabled', '');
    else label.removeAttribute('is-disabled');
  }

  function syncAxis(card, itemSelector, data, axisKey, axisOtherKey, otherValue) {
    card.querySelectorAll(itemSelector).forEach(function (item) {
      var radio = item.querySelector('[type="radio"]');
      var label = item.querySelector('label');
      if (!radio) return;
      var flags = comboFlags(data, axisKey, radio.value, axisOtherKey, otherValue);
      setOptionState(item, label, !flags.availableAnywhere, !flags.exists || !flags.available);
    });
  }

  function setVariantLinks(card, variantId) {
    if (!variantId) return;
    var id = String(variantId);
    card.querySelectorAll('a[href*="/products/"]').forEach(function (link) {
      try {
        var url = new URL(link.href, window.location.origin);
        if (url.pathname.indexOf('/products/') === -1) return;
        if (url.searchParams.get('variant') === id) return;
        url.searchParams.set('variant', id);
        link.href = url.toString();
      } catch (e) {
        /* ignore invalid href */
      }
    });
  }

  function applyVariantDataset(radio, variant) {
    if (!variant) return;
    radio.dataset.vid = String(variant.id);
    if (variant.img) radio.dataset.vimg = variant.img;
  }

  function syncRadioVariantData(card, data, swatchVal, platformVal, groups) {
    if (!groups || groups.swatch) {
      card.querySelectorAll(SWATCH_GROUP + ' [type="radio"]').forEach(function (radio) {
        applyVariantDataset(radio, findVariant(data, radio.value, platformVal));
      });
    }
    if (!groups || groups.platform) {
      card.querySelectorAll(PLATFORM_GROUP + ' [type="radio"]').forEach(function (radio) {
        applyVariantDataset(radio, findVariant(data, swatchVal, radio.value));
      });
    }
  }

  function checkedValue(card, groupSelector) {
    var radio = card.querySelector(groupSelector + ' [type="radio"]:checked');
    return radio ? radio.value : null;
  }

  function selectRadioValue(card, groupSelector, value) {
    if (!value) return false;
    var radio = card.querySelector(groupSelector + ' [type="radio"][value="' + cssEscape(value) + '"]');
    if (!radio) return false;
    if (!radio.checked) radio.checked = true;
    return true;
  }

  function setMainImage(card, imgUrl) {
    if (!imgUrl) return;
    var mediaMain = card.querySelector('.hdt-card-product__media--main');
    if (!mediaMain || mediaMain.getAttribute('src') === imgUrl) return;

    var parent = mediaMain.parentElement;
    var newImg = mediaMain.cloneNode(false);
    newImg.removeAttribute('srcset');
    newImg.setAttribute('src', imgUrl);

    var widths = [];
    try {
      widths = JSON.parse(mediaMain.getAttribute('data-widths') || '[]') || [];
    } catch (e) {
      widths = [];
    }
    if (widths.length) {
      var sep = imgUrl.indexOf('?') === -1 ? '?' : '&';
      newImg.setAttribute(
        'srcset',
        widths
          .map(function (w) {
            return imgUrl + sep + 'width=' + w + ' ' + w + 'w';
          })
          .join(', ')
      );
    }

    if (parent) {
      parent.removeAttribute('loaded');
      parent.setAttribute('loading', '');
      newImg.addEventListener(
        'load',
        function () {
          parent.removeAttribute('loading');
          parent.setAttribute('loaded', '');
        },
        { once: true }
      );
    }

    mediaMain.replaceWith(newImg);
    card.querySelectorAll('wrapp-hdt-swatches').forEach(function (wrap) {
      if ('mediaMain' in wrap) wrap.mediaMain = newImg;
    });
  }

  function switchPair(data, keepKey, keepVal) {
    var moveKey = keepKey === data.swatchKey ? data.platformKey : data.swatchKey;
    var next = findCompatibleValue(data, keepKey, keepVal, moveKey);
    if (!next) return null;
    var swatchVal = keepKey === data.swatchKey ? keepVal : next;
    var platformVal = keepKey === data.platformKey ? keepVal : next;
    return {
      swatchVal: swatchVal,
      platformVal: platformVal,
      variant: findVariant(data, swatchVal, platformVal),
    };
  }

  function resolveCompatiblePair(data, swatchVal, platformVal, changedGroup) {
    var variant = findVariant(data, swatchVal, platformVal);
    if (variant) {
      return { swatchVal: swatchVal, platformVal: platformVal, variant: variant };
    }

    var resolved;
    if (changedGroup === 'platform') {
      resolved = switchPair(data, data.platformKey, platformVal);
      if (resolved) return resolved;
    }

    resolved = switchPair(data, data.swatchKey, swatchVal);
    if (resolved) return resolved;

    if (changedGroup !== 'platform') {
      resolved = switchPair(data, data.platformKey, platformVal);
      if (resolved) return resolved;
    }

    return { swatchVal: swatchVal, platformVal: platformVal, variant: null };
  }

  function applyDualSelection(card, changedGroup) {
    var data = parseDual(card);
    if (!data) return;

    var swatchVal = checkedValue(card, SWATCH_GROUP);
    var platformVal = checkedValue(card, PLATFORM_GROUP);
    if (!swatchVal || !platformVal) return;

    var resolved = resolveCompatiblePair(data, swatchVal, platformVal, changedGroup || null);
    if (resolved.platformVal !== platformVal) {
      selectRadioValue(card, PLATFORM_GROUP, resolved.platformVal);
      platformVal = resolved.platformVal;
    }
    if (resolved.swatchVal !== swatchVal) {
      selectRadioValue(card, SWATCH_GROUP, resolved.swatchVal);
      swatchVal = resolved.swatchVal;
    }

    syncAxis(card, PLATFORM_GROUP + ' .hdt-platform-list__item', data, data.platformKey, data.swatchKey, swatchVal);
    syncAxis(card, SWATCH_GROUP + ' .hdt-color-list__item', data, data.swatchKey, data.platformKey, platformVal);

    if (!resolved.variant) return;

    syncRadioVariantData(card, data, swatchVal, platformVal);
    setVariantLinks(card, resolved.variant.id);
    setMainImage(card, resolved.variant.img);

    // Theme Swatches rewrites color data-vid after us — re-assert on next frame.
    requestAnimationFrame(function () {
      syncRadioVariantData(card, data, swatchVal, platformVal, { swatch: true });
      setVariantLinks(card, resolved.variant.id);
    });
  }

  function initDualCards(root) {
    (root || document).querySelectorAll(CARD_SEL).forEach(function (card) {
      if (!card.querySelector(DUAL_SEL)) return;
      cache.delete(card);
      card.setAttribute(READY_ATTR, '');
      applyDualSelection(card, null);
    });
  }

  document.addEventListener(
    'change',
    function (event) {
      var radio = event.target;
      if (!(radio instanceof HTMLInputElement) || radio.type !== 'radio') return;
      var card = radio.closest(CARD_SEL);
      if (!card || !card.hasAttribute(READY_ATTR)) return;

      var changedGroup = null;
      if (radio.closest(SWATCH_GROUP)) changedGroup = 'swatch';
      else if (radio.closest(PLATFORM_GROUP)) changedGroup = 'platform';
      else return;

      queueMicrotask(function () {
        applyDualSelection(card, changedGroup);
        radio.blur();
      });
    },
    true
  );

  document.addEventListener('shopify:section:load', function (event) {
    initDualCards(event.target);
  });
  document.addEventListener('products:update', function (event) {
    initDualCards(event.target);
  });

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () {
      initDualCards(document);
    });
  } else {
    initDualCards(document);
  }
})();
